import { Box, Typography, CircularProgress, Paper } from '@mui/material';
import BuildIcon from '@mui/icons-material/Build';

export const MaintenancePage = () => (
  <Box
    sx={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      bgcolor: 'background.default',
    }}
  >
    <Paper
      elevation={3}
      sx={{
        p: 6,
        maxWidth: 480,
        width: '100%',
        textAlign: 'center',
        borderRadius: 3,
      }}
    >
      <BuildIcon sx={{ fontSize: 64, color: 'primary.main', mb: 2 }} />
      <Typography variant="h5" fontWeight={700} gutterBottom>
        Down for Maintenance
      </Typography>
      <Typography variant="body1" color="text.secondary" mb={3}>
        We're performing scheduled maintenance and will be back shortly.
      </Typography>
      <CircularProgress size={24} />
    </Paper>
  </Box>
);
